export { default } from './HeroStatementBlock';
export * from './HeroStatementBlock';
